// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2A6pT","location":"Header_location__suNP3"};